import { IMultiSelectedValueItem } from '../../../components/Dialogs/MultiSelectedValueDialog'
import { IPayment } from '../../../core/types/Payment'
import {
  TPaymentMethodEnum,
  TProductFrequency,
  TProductPrice,
  TProductTypePayment,
} from '../../../core/types/Product'

export function getMaxInstallments(options: number[]): number {
  return Math.max(...options)
}

export function getPaymentSelected(
  p: IPayment,
  current: TProductPrice,
  options: number[]
): IMultiSelectedValueItem {
  const filtered = current.paymentMethods.find((pm) => pm.methodType === p.id)

  const selected = !!filtered
  let value = 1

  if (p.id === TPaymentMethodEnum.CreditCard) {
    value = selected
      ? filtered!.installmentsNumber
      : getMaxInstallments(options)
  }

  return {
    id: p.id.toString(),
    name: p.name,
    selected,
    value,
    hasValue: p.hasInstallments,
  }
}

export function processPayment(
  p: IPayment,
  current: TProductPrice,
  options: number[],
  typePaymentValue: TProductTypePayment
): IMultiSelectedValueItem {
  if (typePaymentValue === TProductTypePayment.RecurringSubscription) {
    if (
      [TPaymentMethodEnum.CreditCard, TPaymentMethodEnum.Pix].includes(p.id)
    ) {
      return getPaymentSelected(p, current, options)
    }

    if (current.frequency === TProductFrequency.Yearly) {
      return getPaymentSelected(p, current, options)
    }
  }

  return getPaymentSelected(p, current, options)
}
